import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from '@/store';
import { sendAllNotificationsRead, sendNotificationRead } from "@/api/push";
import responseHandler from "../modules/responseHandler";
import { getList } from "@/api/crud";


@Module({ dynamic: true, store, name: 'NotificationsModule', namespaced: true })
class NotificationsModule extends VuexModule {
    isShow;
    isLoading;
    notifications: any[];

    currentPage;
    totalPages;

    constructor(module: NotificationsModule) {
        super(module);

        this.isShow = false;
        this.isLoading = false;
        this.notifications = [];
        this.currentPage = 1;
        this.totalPages = 1;
    }

    @Mutation
    SET_IS_SHOW(bool: boolean) {
        this.isShow = bool;
    }

    @Mutation
    SET_NOTIFICATIONS(list: any[]) {
        this.notifications = list;
    }

    @Mutation
    UNSHIFT_NOTIFICATIONS(prepend: any[]) {
        this.notifications.unshift(...prepend);
    }

    @Mutation
    SET_IS_LOADING(bool: boolean) {
        this.isLoading = bool;
    }

    @Mutation
    SET_TOTAL_PAGES(total: number) {
        this.totalPages = total;
    }

    @Mutation
    SET_CURRENT_PAGE(current: number) {
        this.currentPage = current;
    }

    @Action({ rawError: true })
    init() {
        this.getNotifications();
    }

    @Action({ rawError: true })
    toggleIsShow() {
        this.SET_IS_SHOW(!this.isShow);
    }

    @Action({ rawError: true })
    updateIsShow(bool: boolean) {
        this.SET_IS_SHOW(bool);
    }

    @Action({ rawError: true })
    async readAll() {
        try {
            const result = await sendAllNotificationsRead();

            if (result === 'ok') {
                this.SET_NOTIFICATIONS(
                    this.notifications.map(notification => ({ ...notification, readAt: '1' })),
                );
            }
        } catch(error) {
            responseHandler.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async readSingle(id: number) {
        try {
            const result = await sendNotificationRead(id);

            if (result === 'ok') {
                
                const newNotifications =  this.notifications.map(notification => {
                    if (notification.id === id) {
                        notification.readAt = '1';
                    }

                    return notification;
                });

                this.SET_NOTIFICATIONS(newNotifications);
            }
        } catch(error) {
            responseHandler.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    nextPage() {
        if (this.currentPage === this.totalPages) {

            return;
        }

        this.SET_CURRENT_PAGE(this.currentPage + 1);
        this.getNotifications();
    }

    @Action({ rawError: true })
    async getNotifications() {
        try {
            this.SET_IS_LOADING(true);
            const result = await getList('pushes', { page: this.currentPage });

            if (result?.table?.rows) {
                this.SET_NOTIFICATIONS(this.notifications.concat(result.table.rows));
            }

            const pagination = result?.table?.pagination;
            this.SET_CURRENT_PAGE(pagination?.currentPage ?? this.currentPage);
            this.SET_TOTAL_PAGES(pagination?.totalPages ?? this.totalPages);
            this.SET_IS_LOADING(false);
        } catch(error) {
            responseHandler.showNotify({ message: error, type: 'fail' });
            this.SET_IS_LOADING(false);
        }
    }

    @Action({ rawError: true })
    async updateNotifications() {
        this.SET_IS_LOADING(true);

        try {
            const result = await getList('pushes', { page: 1 });

            if (!result?.table?.rows) {
                this.SET_IS_LOADING(false);
                return;
            }

            const prepend = result.table.rows.filter((row: any) => {
                return !this.notifications.find(notification => notification.id === row.id);
            });

            this.UNSHIFT_NOTIFICATIONS([...prepend])
            this.SET_IS_LOADING(false);
        } catch(error) {
            responseHandler.showNotify({ message: error, type: 'fail' });
            this.SET_IS_LOADING(false);
        }
    }
}
export default getModule(NotificationsModule);